<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    tabindex="-1"
    id="offcanvas"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ type === 'CREATE'? $t('Create Supplier'): $t('Edit Supplier')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom mb-3 px-3 py-2">
        <i class="fa-solid fa-circle-info me-2" />
        {{ $t('Supplier Information') }}
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
          <div class="col-md-4">
            <label
              for="fullname"
              class="form-label"
            >
              {{ $t('Name') }}
              <span class="text-danger">*</span>
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="fullname"
                type="text"
                v-model.trim="v$.form.fullname.$model"
                class="form-control"
                :class="v$.form.fullname.$error || (errors?.fullname?.length && oldParams.fullname == form.fullname)? 'is-invalid': ''"
                :placeholder="$t('Enter Supplier fullname') + '...'"
                :disabled="viewOnly"
              >
              <div v-for="error of v$.form.fullname.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.fullname === form.fullname">
                <div v-for="error of errors.fullname"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-4">
            <label
              for="branch"
              class="form-label"
            >
              {{ $t('Branch') }}
              <span class="text-danger">*</span>
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="branch"
                type="text"
                v-model.trim="v$.form.branch.$model"
                class="form-control"
                :class="v$.form.branch.$error || (errors?.branch?.length && oldParams.branch == form.branch)? 'is-invalid': ''"
                :placeholder="$t('Enter Supplier branch') + '...'"
                :disabled="viewOnly"
              >
              <div v-for="error of v$.form.branch.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.branch === form.branch">
                <div v-for="error of errors.branch"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-4">
            <label
              class="form-label"
            >
              {{ $t('Tax Policy') }}
              <span class="text-danger">*</span>
            </label>
            <select2
              v-model="v$.form.tax_policy.$model"
              :options="select2TaxPolicy.options"
              :settings="select2TaxPolicy.setting"
            />
          </div>
          <div class="col-md-4">
            <label
              for="tax_id"
              class="form-label"
            >
              {{ $t('Tax ID') }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="tax_id"
                type="text"
                inputmode="numeric"
                maxlength="13"
                v-model.trim="v$.form.tax_id.$model"
                class="form-control"
                :class="v$.form.tax_id.$error || (errors?.tax_id?.length && oldParams.tax_id == form.tax_id)? 'is-invalid': ''"
                :placeholder="'0123456789012'"
                :disabled="viewOnly"
              >
              <div v-for="error of v$.form.tax_id.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.tax_id === form.tax_id">
                <div v-for="error of errors.tax_id"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-6">
            <label
              for="email"
              class="form-label"
            >
              {{ $t('Email') }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="email"
                type="email"
                v-model.trim="v$.form.email.$model"
                class="form-control"
                :class="v$.form.email.$error || (errors?.email?.length && oldParams.email == form.email)? 'is-invalid': ''"
                :placeholder="$t('Enter email') + '...'"
                :disabled="viewOnly"
              >
              <div v-for="error of v$.form.email.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.email === form.email">
                <div v-for="error of errors.email"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-3">
            <label
              for="telephone1"
              class="form-label"
            >
              {{ $t('Telephone') + 1 }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="telephone1"
                type="tel"
                v-model.trim="v$.form.telephone1.$model"
                class="form-control"
                :class="v$.form.telephone1.$error || (errors?.telephone1?.length && oldParams.telephone1 == form.telephone1)? 'is-invalid': ''"
                :placeholder="$t('Enter telephone') + '...'"
                :disabled="viewOnly"
              >
              <div v-for="error of v$.form.telephone1.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.telephone1 === form.telephone1">
                <div v-for="error of errors.telephone1"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-3">
            <label
              for="telephone2"
              class="form-label"
            >
              {{ $t('Telephone') + 2 }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="telephone2"
                type="tel"
                v-model.trim="v$.form.telephone2.$model"
                class="form-control"
                :class="v$.form.telephone2.$error || (errors?.telephone2?.length && oldParams.telephone2 == form.telephone2)? 'is-invalid': ''"
                :placeholder="$t('Enter telephone') + '...'"
                :disabled="viewOnly"
              >
              <div v-for="error of v$.form.telephone2.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.telephone2 === form.telephone2">
                <div v-for="error of errors.telephone2"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="border-bottom mb-3 px-3 py-2">
        <i class="fa-solid fa-house-flag me-2" />
        {{ $t('Supplier Address') }}
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
          <div class="col-md-12">
            <label
              for="address"
              class="form-label"
            >
              {{ $t('Address') }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="address"
                type="text"
                v-model.trim="v$.form.address.$model"
                class="form-control"
                :class="v$.form.address.$error || (errors?.address?.length && oldParams.address == form.address)? 'is-invalid': ''"
                :placeholder="$t('Enter address') + '...'"
                :disabled="viewOnly"
              >
              <div v-for="error of v$.form.address.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.address === form.address">
                <div v-for="error of errors.address"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-3" >
            <label for="postal_code" class="form-label">
              {{ $t('Zipcode') }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <input
                id="postal_code"
                type="text"
                v-model.trim="v$.form.postal_code.$model"
                class="form-control"
                :class="v$.form.postal_code.$error || (errors?.postal_code?.length && oldParams.postal_code == form.postal_code)? 'is-invalid': ''"
                :placeholder="$t('Enter zipcode') + '...'"
                :disabled="viewOnly"
              >
              <div v-for="error of v$.form.postal_code.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
              <template v-if="oldParams.postal_code === form.postal_code">
                <div v-for="error of errors.postal_code"
                  class="invalid-feedback"
                >
                  {{ $t(error) }}
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-3">
            <label
              class="form-label"
            >
              {{ $t('Sub District') }}
            </label>
            <select2
              v-model="v$.form.sub_district.$model"
              :class="v$.form.sub_district.$error || (errors?.sub_district?.length && oldParams.sub_district == form.sub_district)? 'is-invalid': ''"
              :options="districts"
              :settings="select2FormAddress.setting"
              :disabled="viewOnly"
              @select="selectAddresses"
            />
            <template v-if="oldParams.sub_district === form.sub_district">
              <div v-for="error of errors.sub_district"
                class="invalid-feedback"
              >
                {{ $t(error) }}
              </div>
            </template>
          </div>
          <div class="col-md-3">
            <label
              class="form-label"
            >
              {{ $t('District') }}
            </label>
            <select2
              v-model="v$.form.district.$model"
              :class="v$.form.district.$error || (errors?.district?.length && oldParams.district == form.district)? 'is-invalid': ''"
              :options="amphoes"
              :settings="select2FormAddress.setting"
              :disabled="viewOnly"
              @select="selectAddresses"
            />
            <template v-if="oldParams.district === form.district">
              <div v-for="error of errors.district"
                class="invalid-feedback"
              >
                {{ $t(error) }}
              </div>
            </template>
          </div>
          <div class="col-md-3">
            <label
              class="form-label"
            >
              {{ $t('Province') }}
            </label>
            <select2
              v-model="v$.form.province.$model"
              :class="v$.form.province.$error || (errors?.province?.length && oldParams.province == form.province)? 'is-invalid': ''"
              :options="provinces"
              :settings="select2FormAddress.setting"
              :disabled="viewOnly"
              @select="selectAddresses"
            />
            <template v-if="oldParams.province === form.province">
              <div v-for="error of errors.province"
                class="invalid-feedback"
              >
                {{ $t(error) }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading"
    >
      <ladda
        text="Save"
        v-if="type === 'CREATE'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleCreate"
      />
      <ladda
        text="Save"
        v-if="type === 'EDIT'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleUpdate"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import { Suppliers } from '@/services/endpoint/suppliers.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import Ladda from '@/plugins/Ladda.vue';
import numeral from 'numeral';
import { searchAddressByZipcode } from 'thai-address-database';
import Select2 from 'vue3-select2-component';

export default {
  filters: {
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.00");
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation
  },
  props: {
    type: {
      type: String,
      default: 'CREATE'
    },
    supplierId: {
      type: Number,
      default: 0
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let vm = this;
    return {
      loading: true,
      loadingSave: false,
      hasPermission: false,
      select2TaxPolicy: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
      form: {
        fullname: '',
        branch: '',
        tax_policy: 'no_tax',
        tax_id: '',
        email: '',
        telephone1: '',
        telephone2: '',
        address: '',
        postal_code: '',
        sub_district: '0',
        district: '0',
        province: '0'
      },
      errors: {
        fullname: [],
        branch: [],
        tax_policy: [],
        tax_id: [],
        email: [],
        telephone1: [],
        telephone2: [],
        address: [],
        postal_code: [],
        sub_district: [],
        district: [],
        province: []
      },
      oldParams: {
        fullname: '',
        branch: '',
        tax_id: '',
        email: '',
        telephone1: '',
        telephone2: '',
        address: '',
        postal_code: '',
        sub_district: '0',
        district: '0',
        province: '0'
      },
      select2FormAddress: {
        setting: {
          minimumResultsForSearch: Infinity,
        }
      },
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    Ladda,
    Select2
  },
  methods: {
    selectAddresses({ id, text, module }) {
      if (module == 'sub_district') {
        if (id != '0') {
          let address = this.addresses.find((addresse) => addresse.district == id);
          this.form.district = address.amphoe;
          this.form.province = address.province;
          this.form.postal_code = address.zipcode;
        }
      }

      if (module == 'district') {
        this.form.sub_district = '0';
        if (id != '0') {
          let address = this.addresses.find((addresse) => addresse.amphoe == id);
          this.form.province = address.province;
          this.form.postal_code = address.zipcode;
        }
      }

      if (module == 'province') {
        this.form.sub_district = '0';
        this.form.district = '0';
        if (id != '0') {
          let address = this.addresses.find((addresse) => addresse.province == id);
          this.form.postal_code = address.zipcode;
        }
      }
    },
    async getCreateData() {
      await Suppliers.getCreate().then(res => {
        const vm = this;
        this.select2TaxPolicy.options = res.data.data.tax_policy.map(function(item) {
          return {
            id: item.value,
            text: vm.$t(item.text)
          }
        });
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    async getUpdateData() {
      await Suppliers.getUpdate(this.supplierId).then(res => {
        const vm = this;
        this.select2TaxPolicy.options = res.data.filter.tax_policy.map(function(item) {
          return {
            id: item.value,
            text: vm.$t(item.text)
          }
        });
        this.form.fullname = res.data.data.fullname;
        this.form.branch = res.data.data.branch;
        this.form.tax_id = res.data.data.tax_id || '';
        this.form.email = res.data.data.email;
        this.form.telephone1 = res.data.data.telephone1;
        this.form.telephone2 = res.data.data.telephone2;
        this.form.address = res.data.data.address;
        this.form.postal_code = res.data.data.postal_code || '';
        this.form.tax_policy = res.data.data.tax_policy;
        setTimeout(() => {
          this.form.sub_district = res.data.data.sub_district || '0';
          this.form.district = res.data.data.district || '0';
          this.form.province = res.data.data.province || '0';
        }, 1);

        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    setParamsBeforeSendCreate() {
      let params = _.clone(this.form);
      return $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
        if (
          (key == 'address' ||
          key == 'postal_code' ||
          key == 'sub_district' ||
          key == 'district' ||
          key == 'province') && value == '0'
        ) {
          delete params[key];
        }
      });
    },
    setParamsBeforeSendUpdate() {
      let params = _.clone(this.form);
      return $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
        if (
          (key == 'address' ||
          key == 'postal_code' ||
          key == 'sub_district' ||
          key == 'district' ||
          key == 'province') && value == '0'
        ) {
          delete params[key];
        }
      });
    },
    async handleCreate() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }

      await Suppliers.create(this.setParamsBeforeSendCreate(this.form)).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Save Product Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.errors) {
          this.oldParams = _.clone(this.form);
          this.errors = err?.response?.data?.errors;
        }
        this.loadingSave = false;
      });
    },
    async handleUpdate() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }

      await Suppliers.update(this.supplierId, this.setParamsBeforeSendUpdate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Product Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.errors) {
          this.oldParams = _.clone(this.form);
          this.errors = err?.response?.data?.errors;
        }
        this.loadingSave = false;
      });
    }
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        if (this.type === 'CREATE') await this.getCreateData();
        if (this.type === 'EDIT') await this.getUpdateData();
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$parent.form.open = false;
    });
  },
  computed: {
    maxUploadImg: function() {
      return this.$t('You can choose to upload a maximum of') + ' ' + this.image.maxImage + ' ' + this.$t('imaes. The size is not over') + ' ' + this.image.maxSize + ' ' + this.$t('MB.');
    },
    addresses() {
      return searchAddressByZipcode(this.form.postal_code, 100);
    },
    districts() {
      if (!this.addresses.find((addresse) => addresse.district == this.form.sub_district)) {
        this.form.sub_district ='0';
      }
      return [
        {
          id: '0',
          text: this.$t('Select')+'...',
          module: 'sub_district'
        }
      ].concat([...new Set(this.addresses.map(item => item.district))].map(item => { return { id: item, text: item, module: 'sub_district' } }));
    },
    amphoes() {
      if (!this.addresses.find((addresse) => addresse.amphoe == this.form.district)) {
        this.form.district ='0';
      }
      return [
        {
          id: '0',
          text: this.$t('Select')+'...',
          module: 'district'
        }
      ].concat([...new Set(this.addresses.map(item => item.amphoe))].map(item => { return { id: item, text: item, module: 'district' } }));
    },
    provinces() {
      if (!this.addresses.find((addresse) => addresse.province == this.form.province)) {
        this.form.province ='0';
      }
      return [{ id: '0', text: this.$t('Select')+'...', module: 'province' }].concat([...new Set(this.addresses.map(item => item.province))].map(item => { return { id: item, text: item, module: 'province' } }));
    },
  }
}
</script>
